import { ConfigureStoreOptions, configureStore } from "@reduxjs/toolkit";
import createSagaMiddleware from "redux-saga";
import { rootSaga } from "./rootSaga";
import rootReducer from "./ReduxIndex";
import generalSlice from "./slice/generalSlice";
import loginSlice from "./slice/loginSlice";

let store: any = null;
const sagaMiddleware = createSagaMiddleware();
const getStore = () => {
  const options: ConfigureStoreOptions = {
    reducer: {
      rootReducer,
      general: generalSlice,
      login: loginSlice
      // Add other reducers here
    },
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({ thunk: false, serializableCheck: false }).concat(
        sagaMiddleware
      )
  };

  store = configureStore(options);

  sagaMiddleware.run(rootSaga);

  return { store };
};

export { getStore, store };

export type StoreDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
